export default "__VITE_ASSET__WOksDIa___"